import { Modal,Box, Button, TextField,Select} from '@mui/material';
import { getUpdateBody, validateUpdateBody } from '../../../_events/orderDetail/orderDetail.input';
import { useState } from 'react';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const UpdateOrderDetailModal = (props) => {

    const [quantityError, setQuantityError] = useState(null);
    const [literFormulaError, setLiterFormulaError] = useState(null);
    const [priceError, setPriceError] = useState(null);

    return (
        
        props.orderDetailUpdate  === null || props.colorList  === null || props.processList  === null ?
            null
            :
            <div>
                <Modal
                    open={props.openUpdateODModal}
                    onClose={props.handleCloseUpdateOrderDetail}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <b><p>EDICION DE PRODUCTO</p></b>
                        <TextField
                            label="Cantidad"
                            id="quantity"
                            defaultValue={props.orderDetailUpdate.quantity || ''}
                            fullWidth
                            margin="normal"
                            error={!!quantityError}
                            helperText={quantityError}
                        />
                        <Select
                            native
                            label=" "
                            inputProps={{
                                name: 'type_quantity',
                                id: 'type_quantity',
                            }}
                            fullWidth
                            style={{ marginBottom: '10px' }} 
                        >
                            
                        {props.orderDetailUpdate.type_quantity === 'KG' ? (
                            <>
                            <option key={'KG'} value={'KG'}>
                                {'KILOS'}
                            </option>
                            <option key={'MTS'} value={'MTS'}>
                                {'METROS'}
                            </option>
                            </>
                        ) : (
                            <>
                            <option key={'MTS'} value={'MTS'}>
                                {'METROS'}
                            </option>
                            <option key={'KG'} value={'KG'}>
                                {'KILOS'}
                            </option>
                            </>
                        )}
                        </Select>
                        
                        <Select
                            native
                            label=" "
                            inputProps={{
                                name: 'color',
                                id: 'color',
                            }}
                            fullWidth
                            style={{ marginBottom: '10px' }} 
                        >
                            {props.colorList
                                ? [
                                    <option key={props.orderDetailUpdate.color.cod} value={props.orderDetailUpdate.color.uuid}>
                                        {props.orderDetailUpdate.color.cod + '-' + props.orderDetailUpdate.color.description}
                                    </option>,
                                    ...props.colorList
                                        .filter(color => color.cod !== props.orderDetailUpdate.color.cod)
                                        .map((color) => (
                                            <option key={color.cod} value={color.uuid}>
                                                {color.cod + '-' + color.description}
                                            </option>
                                        ))
                                ]
                                : null
                            }
                        </Select>


                        <Select
                            native
                            label=" "
                            inputProps={{
                                name: 'cod_process',
                                id: 'cod_process',
                            }}
                            fullWidth

                        >
                           {props.processList
                                ? [
                                    <option key={props.orderDetailUpdate.cod_process} value={props.orderDetailUpdate.cod_process? props.orderDetailUpdate.cod_process : 'DEFE'}>
                                        {props.orderDetailUpdate.cod_process ? props.orderDetailUpdate.cod_process : 'SIN PROCESO'}
                                    </option>,
                                    ...props.processList
                                        .filter(process => process.cod !== props.orderDetailUpdate.cod_process && process.cod !== 'ALIS' && process.cod !== 'PEND')
                                        .map((process) => (
                                            <option key={process.cod} value={process.cod}>
                                                {process.name}
                                            </option>
                                        ))
                                ]
                                : null
                            }
                        </Select>
                        
                        <TextField
                            label="Litros de formula"
                            id="literformula"
                            defaultValue={props.orderDetailUpdate.literformula || 0}
                            fullWidth
                            margin="normal"
                            error={!!literFormulaError}
                            helperText={literFormulaError}
                        />
                        
                        <TextField
                            label="Precio"
                            id="price"
                            defaultValue={props.orderDetailUpdate.price}
                            fullWidth
                            margin="normal"
                            error={!!priceError}
                            helperText={priceError}
                        />

                        <Select
                            native
                            label=" "
                            inputProps={{
                                name: 'inspected',
                                id: 'inspected',
                            }}
                            fullWidth
                            style={{ marginBottom: '10px' }} 
                        >
                            {props.orderDetailUpdate.inspected === 'PASS' ? (
                                <>
                                    <option key={'PASS'} value={'PASS'}>
                                        {'APROBADO'}
                                    </option>
                                    <option key={'WAIT'} value={'WAIT'}>
                                        {'PENDIENTE'}
                                    </option>
                                    <option key={'-'} value={'-'}>
                                        {'NO PROCESADO'}
                                    </option>
                                </>
                            ) : props.orderDetailUpdate.inspected === 'WAIT' ? (
                                <>
                                    <option key={'WAIT'} value={'WAIT'}>
                                        {'PENDIENTE'}
                                    </option>
                                    <option key={'PASS'} value={'PASS'}>
                                        {'APROBADO'}
                                    </option>
                                    <option key={'-'} value={'-'}>
                                        {'NO PROCESADO'}
                                    </option>
                                </>
                            ) : (
                                <>
                                    <option key={'-'} value={'-'}>
                                        {'NO PROCESADO'}
                                    </option>
                                    <option key={'WAIT'} value={'WAIT'}>
                                        {'PENDIENTE'}
                                    </option>
                                    <option key={'PASS'} value={'PASS'}>
                                        {'APROBADO'}
                                    </option>
                                </>
                            )}
                        </Select>

                        
                        <Button
                        variant="contained" 
                        color="primary" 
                        onClick={() => {   
                            let body = getUpdateBody();
                            if(validateUpdateBody(body)==='eq')
                            {
                                setPriceError(null)
                                setQuantityError('Error en la cantidad')
                                setLiterFormulaError(null)

                            }else if(validateUpdateBody(body)==='ef')
                            {
                                setPriceError(null)
                                setQuantityError(null)
                                setLiterFormulaError('Error en los litros de formula')

                            }else if(validateUpdateBody(body)==='pr')
                            {
                                setQuantityError(null)
                                setLiterFormulaError(null)
                                setPriceError('Error en el precio')

                            }else
                            {
                                setLiterFormulaError(null)
                                setQuantityError(null)
                                setPriceError(null)
                                if(props.orderDetailUpdate.cod_process === "REMI" || props.orderDetailUpdate.cod_process === "FACT"){
                                    alert("No puedes actualizar. Esto ya fue remisionado");
                                } else {
                                    props.updateOrderDetail(body);
                                }
                            }
                        }}
                        >
                         Actualizar
                        </Button>


                    </Box>
                </Modal>
            </div>
    );
}

export default UpdateOrderDetailModal;
